<div class="w-full center-container-gray md:pt-2 player-profile">
  <router-outlet/>
</div>
